import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../Demoseal.png';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();

  const validateEmail = (value) => {
    if (!value) return 'Email is required.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Please enter a valid email address (e.g. user@example.com).';
    return '';
  };

  const validatePassword = (value) => {
    if (!value) return 'Password is required.';
    if (value.length < 8) return 'Password must be at least 8 characters.';
    if (!/[A-Z]/.test(value)) return 'Password must contain at least one uppercase letter.';
    if (!/[0-9]/.test(value)) return 'Password must contain at least one number.';
    return '';
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(validateEmail(e.target.value));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordError(validatePassword(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const eErr = validateEmail(email);
    const pErr = validatePassword(password);
    setEmailError(eErr);
    setPasswordError(pErr);
    if (eErr || pErr) return;

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        setError(data.message || 'Invalid username or password.');
        return;
      }
      localStorage.setItem('token', data.token);
      navigate('/dashboard');
    } catch {
      setError('Invalid username or password.');
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-logo-side">
          <div className="signin-hero">
            <img src={logo} alt="NuGrants" className="signin-logo" />
            <div className="signin-hero-copy">
              <p className="signin-kicker">NuGrants</p>
              <h1>Welcome back</h1>
              <p>
                Sign in to review applications, manage programs, and move funding decisions through a
                cleaner shared workspace.
              </p>
            </div>
            <div className="signin-highlights">
              <span>Funding dashboard</span>
              <span>Applications</span>
              <span>Review rounds</span>
            </div>
          </div>
        </div>

        <div className="signin-form-side">
          <div className="signin-form-header">
            <p className="signin-kicker">Account access</p>
            <h2 className="signin-title">Sign In</h2>
            <p className="signin-subtitle">Use your assigned NuGrants credentials to continue.</p>
          </div>

          <form onSubmit={handleSubmit} className="signin-form" noValidate>
            <div className="form-group">
              <label className="signin-label">Email</label>
              <input
                type="email"
                placeholder="name@example.com"
                value={email}
                onChange={handleEmailChange}
                className={`form-input ${emailError ? 'input-error' : ''}`}
              />
              {emailError && <p className="field-error">{emailError}</p>}
            </div>

            <div className="form-group password-group">
              <label className="signin-label">Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={password}
                  onChange={handlePasswordChange}
                  className={`form-input ${passwordError ? 'input-error' : ''}`}
                />
                <button
                  type="button"
                  className="eye-icon-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                >
                  {showPassword ? (
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="3" />
                      <path d="M12 5C7 5 2.73 8.11 1 12.46c1.73 4.35 6 7.54 11 7.54s9.27-3.19 11-7.54C21.27 8.11 17 5 12 5z" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <line x1="1" y1="1" x2="23" y2="23" strokeLinecap="round" />
                    </svg>
                  )}
                </button>
              </div>
              {passwordError && <p className="field-error">{passwordError}</p>}
            </div>

            <button type="submit" className="signin-button">Sign In</button>
            {error && <p className="field-error">{error}</p>}
          </form>

          <div className="signin-help">
            <span>Need access?</span>
            <button type="button" className="link-btn" onClick={() => navigate('/')}>
              Return to overview
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
